import httpClient from "@/apis/base/httpclient";
import api from "@/apis/system/locationAPI";
import Crud from "@/stores/crudBase";

var crud = new Crud("Location", api);

const state = {
  ...crud.state,

  _config: {
    field: {
      key: "LocationID",
      name: "LocationName",
    },
  },
  datas: [],
};

const getters = {
  ...crud.getters,
};

/**
 * Chứa các hàm action
 */
const actions = {
  ...crud.actions,

  /**
   * Lấy danh sách Tỉnh/Thành phố
   * VDGiang 10/11/2022
   */
  async getAllProvince() {
    let request = {
      url: api.getAPIUrl() + "/provinces",
    };
    let res = await httpClient.getAsync(request);
    return res;
  },

  /**
   * Lấy danh sách Quận/huyện
   * VDGiang 10/11/2022
   */
  async getDistrictByProvinceID(context, payload) {
    let request = {
      url: api.getAPIUrl() + `/districts/${payload.provinceID}`,
      //  data: payload,
    };
    let res = await httpClient.getAsync(request);
    return res;
  },

  /**
   * Lấy danh sách Xã/phường
   * VDGiang 10/11/2022
   */
  async getWardByDistrictID(context, payload) {
    let request = {
      url: api.getAPIUrl() + `/wards/${payload.districtID}`,
    //   data: payload,
    };
    let res = await httpClient.getAsync(request);
    return res;
  },
};

const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== "production",
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
